import { ComparatorUtils } from './comparator-utils';
import { DropdownItem } from '../models/dropdown-item';

export class PioneerUtils {
  static getLastElement(elements: any[]) {
    return elements && elements.length > 0 ? elements[elements.length - 1] : null;
  }

  static safeTrim(value: string): string {
    return !value ? value : value.trim();
  }

  static trimToNull(value: string): string {
    const trimmedValue = this.safeTrim(value);
    return trimmedValue && trimmedValue.length > 0 ? trimmedValue : null;
  }

  static orderDropdownByValue(dropdownItems: DropdownItem[]) {
    dropdownItems.sort((anItem, anotherItem) => {
      return ComparatorUtils.compareString(anItem.value, anotherItem.value);
    });
  }

  static safeSubstring(value: string, start: number, end?: number): string {
    let result = undefined;
    if (value) {
      if (end) {
        result = value.substring(start, end);
      } else {
        result = value.substring(start);
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/utils/pioneer-utils.ts